<template>
    <div class="animated fade-in">

        <h1 class="display-4 font-weight-lighter">Sent Estimates</h1>

        <estimate-table :status_filter="['Sent']"></estimate-table>

    </div>
</template>

<script>
    import EstimateTable from "../../components/estimates/EstimateTable";

    export default {
      name: 'EstimateApprove',
      components: {EstimateTable}
	}
</script>
